import React, { useEffect, useState, useCallback } from "react";
import "./ClassSidebar.css";
import { doc, setDoc, deleteDoc, updateDoc } from "firebase/firestore";

import { db } from "../firebase"; 
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getDocs,
} from "firebase/firestore";



async function uploadUnitPdf(userId, classId, file, unitName) {
  const form = new FormData();
  form.append("file", file);
  form.append("userId", userId);
  form.append("classId", classId);
  if (unitName) form.append("unitName", unitName);

  const res = await fetch("http://localhost:8000/api/units/upload", {
    method: "POST",
    body: form,
  });


  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Upload failed");
  }

  return res.json(); // { unitId, written, message }
}











const ClassSidebar = ({
  userId,             
  selectedClassId,
  selectedUnitId,
  onSelectClass,
  onSelectUnit,
}) => {
  const [expanded, setExpanded] = useState({});
  const [classes, setClasses] = useState([]);            // [{id, name, email, joinedAt}]
  const [unitsByClass, setUnitsByClass] = useState({});  // { [classId]: [{id, name, order}] }
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

    
  const deleteUnit = async (classId, unitId) => {
    if (!window.confirm("Are you sure you want to delete this unit?")) return;
    try {
      await deleteDoc(doc(db, "Users", userId, "Classes", classId, "Units", unitId));
      console.log("🗑️ Deleted unit:", unitId);
      // Refresh units
      fetchUnitsForClass(classId);
    } catch (err) {
      console.error("❌ Failed to delete unit:", err);
      alert(err.message || "Failed to delete unit");
    }
  };

  const renameUnit = async (classId, unitId, oldName) => {
    const newName = prompt("Enter new name for this unit:", oldName);
    if (!newName || newName === oldName) return;
    try {
      await updateDoc(doc(db, "Users", userId, "Classes", classId, "Units", unitId), {
        name: newName,
      });
      console.log("✏️ Renamed unit:", unitId, "→", newName);
      // Refresh units
      fetchUnitsForClass(classId);
    } catch (err) {
      console.error("❌ Failed to rename unit:", err);
      alert(err.message || "Failed to rename unit");
    }
  };

  const deleteClass = async (classId) => {
    if (!window.confirm("Are you sure you want to delete this entire class and all its units?")) return;
    try {
      await deleteDoc(doc(db, "Users", userId, "Classes", classId));
      console.log("🗑️ Deleted class:", classId);
    } catch (err) {
      console.error("❌ Failed to delete class:", err);
      alert(err.message || "Failed to delete class");
    }
  };




 
  useEffect(() => {
    if (!userId) return;

    const classesRef = collection(db, "Users", userId, "Classes");
    
    const q = query(classesRef,);

    const unsub = onSnapshot(
      q,
      (snap) => {
        const list = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            name: data?.name ?? "(unnamed class)",
            email: data?.email ?? "",
            joinedAt: data?.joinedAt ?? null,
          };
        });
        setClasses(list);
        setLoading(false);

        console.log("Classes snapshot size:", snap.size);
        snap.forEach((doc) => {
            console.log("Class doc:", doc.id, doc.data());
        });
        
      },
      (err) => {
        console.error("Classes onSnapshot error:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [userId]);

  const addNewClass = async () => {
    const name = prompt("Enter new class name:");
    if (!name) return;
    try {
      const classRef = doc(collection(db, "Users", userId, "Classes"));
      await setDoc(classRef, {
        name,
        createdAt: new Date(),
      });
      console.log("✅ Added new class:", name);
    } catch (err) {
      console.error("❌ Failed to add class:", err);
      alert(err.message || "Failed to add class");
    }
  };








  const fetchUnitsForClass = useCallback(
    async (classId) => {
      if (!userId) return;
      if (unitsByClass[classId]) return; 

      try {
        const unitsRef = collection(
          db,
          "Users",
          userId,
          "Classes",
          classId,
          "Units"
        );
        // order by "order" field if you set it in Firestore
        const q = query(unitsRef,);
        const snap = await getDocs(q);

        const units = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            name: data?.name ?? d.id,
            order: data?.order ?? 9999,
          };
        });

        setUnitsByClass((prev) => ({ ...prev, [classId]: units }));
      } catch (e) {
        console.error("Failed to fetch units:", e);
      }
    },
    [userId, unitsByClass]
  );

  const toggleExpand = async (id) => {
    const willOpen = !expanded[id];
    setExpanded((prev) => ({ ...prev, [id]: willOpen }));
    if (willOpen) {
      // lazy-load units once
      fetchUnitsForClass(id);
    }
  };

  if (loading) {
    return (
      <div className="class-sidebar">
        <h3>Classes</h3>
        <div style={{ padding: "8px", fontSize: "0.9em", color: "#666" }}>
          Loading…
        </div>
      </div>
    );
  }

  return (
    <div className="class-sidebar">

      <h3>Classes</h3>
      <div style={{ marginBottom: "10px" }}>
        <button
          className="add-unit-btn"
          onClick={addNewClass}
        >
          ➕ Add Class
        </button>
      </div>
      {classes.length === 0 ? (
        <div style={{ padding: "8px", fontSize: "0.9em", color: "#666" }}>
          No classes yet.
        </div>
      ) : (
        <ul>
          {classes.map((cls) => {
            const isOpen = !!expanded[cls.id];
            const units = unitsByClass[cls.id] || [];

            return (
              <li key={cls.id}>
                {/* Class pill */}
                <div
                  className={`class-item ${
                    selectedClassId === cls.id ? "active" : ""
                  }`}
                  onClick={() => {
                    onSelectClass?.(cls.id);
                    toggleExpand(cls.id);
                  }}
                >
                  <span>{cls.name}</span>
                  <span className="caret">{isOpen ? "▾" : "▸"}</span>
                </div>
                
                <div style={{ marginLeft: "10px", marginBottom: "5px" }}>
                  <button
                    className="unit-action-btn"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent toggling unit
                      deleteClass(cls.id);
                    }}
                  >
                    Delete Class
                  </button>
                </div>

                {/* Units inside class */}
                {isOpen && (
                  <ul className="unit-list">
                    {units.length === 0 ? (
                      <li className="unit-item" style={{ opacity: 0.7 }}>
                        No units
                      </li>
                    ) : (
                      units.map((unit) => (
                        <li
                          key={unit.id}
                          className={`unit-item ${selectedUnitId === unit.id ? "active" : ""}`}
                          onClick={() => onSelectUnit?.(unit.id, unit.name)}

                        >
                          <span>{unit.name}</span>

                          {/* Actions */}
                          <span style={{ marginLeft: "8px" }}>
                            <button
                              className="unit-action-btn"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent selecting unit
                                renameUnit(cls.id, unit.id, unit.name);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="unit-action-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteUnit(cls.id, unit.id);
                              }}
                            >
                              X
                            </button>
                          </span>
                        </li>
                      ))

                    )}

                    {/* Add Unit Section */}
                    <li className="add-unit">
                      <label className="add-unit-btn">
                        ➕ Add Unit (PDF)
                        <input
                          type="file"
                          accept=".pdf,.pptx,.ppt"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const unitName = prompt("Enter a name for this unit:");
                              try {
                                setUploading(true);  // 🔹 show spinner
                                console.log("📂 Uploading file:", file.name);
                                const result = await uploadUnitPdf(userId, cls.id, file, unitName);
                                console.log("✅ Upload success:", result);

                                fetchUnitsForClass(cls.id); // refresh
                              } catch (err) {
                                console.error("❌ Upload error:", err);
                                alert(err.message || "Failed to upload file");
                              } finally {
                                setUploading(false);  // 🔹 hide spinner
                              }
                            }
                          }}


                        />
                      </label>
                      {uploading && (
                        <div className="upload-spinner">
                          <div className="spinner" />
                          <span>Generating files...</span>
                        </div>
                      )}

                    </li>

                    
                  </ul>
                )}

              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ClassSidebar;
